import { getRate } from '@trippath/shared';
import { useEffect, useState } from 'react';

/**
 * The money a price at a town is typed in first: the town's own when the trip has a rate for it
 * that day — so it can be counted in the trip's — else the trip's own. Until the rate is known,
 * the trip's.
 */
export function useTownMoney(
  trip: string,
  town: string | null,
  tripCurrency: string,
  day: string | null,
): string {
  const [rated, setRated] = useState<string | null>(null);
  useEffect(() => {
    if (town === null || town === tripCurrency || day === null) return;
    void getRate(trip, town, day)
      .catch(() => null)
      .then((found) => {
        setRated(found ? `${town} ${day}` : null);
      });
  }, [trip, town, tripCurrency, day]);
  return town !== null && rated === `${town} ${String(day)}` ? town : tripCurrency;
}
